import React from 'react';
import Timeline from '../../components/Timeline/Timeline';
import FontAwesome from 'react-fontawesome';

const Welcome = ({ priorCarrier }) => {
    return (
        <Timeline
            seperator="WELCOME ABOARD"
            heading="welcome to Safeco"
            icon={
                <FontAwesome
                    className="primary-yellow con md image_center icon15"
                    name="handshake-o"
                    datacy="handshake"
                    size="2x"
                />
            }>
            {priorCarrier
                ? `${priorCarrier} just finished reviewing your insurance program `
                : 'After reviewing your policy '}
            to make sure you are getting the best value and coverage for your needs, your agent has
            recommended a switch to Safeco. We look forward to being your insurance provider.
        </Timeline>
    );
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/containers/Welcome/Welcome.jsx